/**
 * RFQ 매입처 버블 메타 렌더 — 소싱/딜 상세 공용 (기획 §5.5.18-20).
 *
 * 버블 = 매입처 [대체품목] [대체컨디션] [가격|재고없음] [RFQ메모] [✎기타메모]
 * (매입처명은 호출부에서 앞에 붙임. 여기선 그 뒤 메타만 반환.)
 */
import type { SourcingRfqBubble } from '../api/client';
import { escapeHtml } from './cells';

export function renderRfqBubbleMeta(r: SourcingRfqBubble): string {
  const cur = r.price_currency === 'USD' ? '$' : '₩';
  // 재고 없음 / 실제 가격만 표시. '문의 예정'·'답변 대기' 등 응답 전 상태는
  // 버블에 노출하지 않는다(응답 전이면 매입처명만 남음).
  const priceStr = r.status === '재고 없음'
    ? '재고 없음'
    : r.price_amount != null
      ? `${cur}${r.price_amount}`
      : '';
  // 대체품목/대체컨디션/가격 순서, 사이 하이픈 없음(§5.5.19)
  const mainParts = [r.alternative_part ?? '', r.sourced_condition ?? '', priceStr].filter(Boolean);
  const main = mainParts.length
    ? `<span class="rfq-bubble-main">${mainParts.map((p) => `<span class="rfq-bubble-part">${escapeHtml(p)}</span>`).join('')}</span>`
    : '';
  const tags = r.rfq_memo_tags.length
    ? `<span class="rfq-bubble-tags">${escapeHtml(r.rfq_memo_tags.join(', '))}</span>`
    : '';
  const memo = (r.request_note ?? '').trim()
    ? `<span class="rfq-bubble-memo" title="${escapeHtml(r.request_note ?? '')}" aria-label="기타 메모 있음">✎</span>`
    : '';
  // 거래처 수신 첨부(이미지/PDF) 있으면 아이콘 (마이그141)
  const img = r.attachments.length > 0
    ? `<span class="rfq-bubble-img" title="첨부 ${r.attachments.length}건" aria-label="첨부 있음">🖼</span>`
    : '';
  return `${main}${tags}${memo}${img}`;
}
